export default {
  FETCH: 'ADMINISTRATOR_PERMISSIONS/FETCH',
  SET: 'ADMINISTRATOR_PERMISSIONS/SET',
}
